var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'tt-tool ' + (_vm.Active ? 'toggled' : ''),on:{"click":function($event){return _vm.Clicked()}}},[_c('img',{staticStyle:{"width":"24px"},attrs:{"src":_vm.svgUrl,"alt":"SVG Image"}})])}
var staticRenderFns = []

export { render, staticRenderFns }